import { Layout } from "@mcleod/components";

export abstract class AutogenLayoutDetentionCharges extends Layout {
}
